// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AddToList: React.FC = () => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 12 12" enableBackground="new 0 0 12 12" xmlSpace="preserve">
<path fill="currentColor" fillRule="evenodd" clipRule="evenodd" d="M5.99,10.41L1.36,6.8L0.34,7.6L6,12l5.66-4.4l-1.03-0.8L5.99,10.41z M6,8.81
   l4.63-3.61l1.03-0.8L6,0L0.34,4.4l1.03,0.8L6,8.81z"/>
</svg>;
};

export default React.memo(AddToList);
